import { atom } from 'jotai';

import {
  warehouseCredentialCreateMutationAtom,
  warehouseCredentialUpdateMutationAtom,
} from '../_graphql/mutationWarehouseCredential';
import { warehouseCredentialQueryAtom } from '../_graphql/queryWarehouseCredential';

export type EntitlementKey = 'reports';

// 🔘🔘🔘 PLAIN ATOMS
export const $selectedEntitlement = atom<EntitlementKey>('reports');

// 🟢🟢🟢 REMOTE DATA
export const $remoteWarehouseCredential = warehouseCredentialQueryAtom();

// 🟢🟢🟢 COMPUTED DATA
export const $warehouseCredential = atom((get) => {
  const remote = get($remoteWarehouseCredential);
  return remote.data?.entries[0] ?? null;
});

// 🟠🟠🟠 ACTION — create warehouse credential
export const $createWarehouseCredential = warehouseCredentialCreateMutationAtom(
  {
    onSuccess: (get) => {
      get($remoteWarehouseCredential).refetch();
    },
  },
);

// 🟠🟠🟠 ACTION — update warehouse credential
export const $updateWarehouseCredential = warehouseCredentialUpdateMutationAtom(
  {
    onSuccess: (get) => {
      get($remoteWarehouseCredential).refetch();
    },
  },
);
